module.exports = __webpack_public_path__ + "static/media/OBRAS.32441161.png";